import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { startPreviewSession } from '../lib/auth';

/**
 * Landing page for the admin's "preview as speaker" flow.
 *
 * Worker mints a short-lived speaker JWT and the admin's browser opens
 * `/preview?token=…&email=…&eventId=…` in a fresh tab. We stash the
 * session in tab-scoped sessionStorage (so the admin's own localStorage
 * session in the original tab is untouched), then redirect into the
 * speaker UX.
 */
export function PreviewLandingScene() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get('token');
    const email = params.get('email');
    const eventId = params.get('eventId');
    const target = params.get('target') ?? 'waiting';

    if (!token || !email) {
      navigate('/login', { replace: true });
      return;
    }

    startPreviewSession({ token, email, role: 'speaker' });

    if (eventId && target === 'waiting') {
      navigate(`/waiting/${eventId}`, { replace: true });
    } else if (eventId && target === 'rehearse') {
      navigate(`/rehearse/${eventId}`, { replace: true });
    } else {
      navigate('/me', { replace: true });
    }
  }, [params, navigate]);

  return (
    <div style={{ padding: 48, textAlign: 'center' }}>
      <p>Opening preview…</p>
    </div>
  );
}
